module.exports = __webpack_public_path__ + "img/icon-favourite-outline.cd2b6be8.png";